module.exports = "/images/error-icon.svg?cb29d32f63901a7068c4aaf229658c20";